module.exports = __webpack_public_path__ + "static/media/serviceLevel.993bf3fa.png";